import React from 'react';

interface IOrganizationLocationContext {
  organizationCoreId: string | null;
  locationCoreId: string | null;
  isSwitchingOrganization: boolean;
  setContext: (
    organizationCoreId: string | null,
    organizationAlternateId: string | null,
    locationCoreId: string | null
  ) => void;
}

const OrganizationLocationContext =
  React.createContext<IOrganizationLocationContext>({
    organizationCoreId: null,
    locationCoreId: null,
    isSwitchingOrganization: false,
    setContext: () => {},
  });

export default OrganizationLocationContext;
